"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerMobileTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PodcastPlayerMobileTitle = ({ title, isRunning, }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "podcast-player-mobile-title overflow-hidden whitespace-nowrap w-full relative", children: (0, jsx_runtime_1.jsxs)("div", { className: `podcast-player-mobile-title__container inline-block whitespace-nowrap ${isRunning ? 'running animate-slide animation-running' : ''}`, children: [(0, jsx_runtime_1.jsx)("span", { className: "pr-[50px]", children: title }), (0, jsx_runtime_1.jsx)("span", { children: title })] }) }));
};
exports.PodcastPlayerMobileTitle = PodcastPlayerMobileTitle;
